/** Progress bar + current phase for a reviewed session (missing values degrade gracefully). */
import type { SessionStatus } from '@luminis/protocol';
import { sessionPhase, sessionProgress } from '../lib/sessions';
import type { SessionView } from '../lib/types';

const BAR_TONES: Record<SessionStatus, string> = {
  active: 'bg-emerald-400',
  idle: 'bg-amber-400',
  done: 'bg-slate-500',
  error: 'bg-rose-500',
};

export function SessionProgress({
  session,
  showHead = true,
}: {
  session: SessionView;
  showHead?: boolean;
}) {
  const progress = sessionProgress(session);
  const phase = sessionPhase(session);
  if (progress === null && !phase) return null;
  return (
    <div className="mt-2" aria-label={`会话进度 ${progress === null ? '未知' : `${progress}%`}`}>
      {showHead ? (
        <div className="flex items-center justify-between gap-2 text-[10px] text-slate-500">
          <span className="truncate">{phase ?? '阶段未知'}</span>
          <span className="shrink-0 font-mono">{progress === null ? '—' : `${progress}%`}</span>
        </div>
      ) : null}
      {progress !== null ? (
        <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-white/10">
          <div
            className={`h-full rounded-full transition-[width] duration-500 ${BAR_TONES[session.status]}`}
            style={{ width: `${progress}%` }}
          />
        </div>
      ) : null}
    </div>
  );
}
